// index.html 인라인 가드에도 같은 문자열이 하드코딩되어 있다. 함께 수정해야 한다.
export const PRERENDERED_PATH_META_NAME = 'x-prerendered-path';

export const APP_SHELL_ATTRIBUTE = 'data-app-shell';

export const APP_SHELL_SPLASH_ID = 'app-splash';
